import React, { Fragment, useEffect } from 'react'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'

import { Icon } from 'loyal-react'
import { Logo } from './Logo'

const BasicHeader = () => {
  useEffect(() => {
    document.querySelectorAll('#meu-negocio').length > 0 && document.querySelector('#meu-negocio').focus()
  })

  function handleBackStep () {
    setTimeout(() => {
      document.querySelector('#checkoutBackStep').click()
    }, 300)
  }

  return (
    <Fragment>
      <MediaQuery maxWidth={480}>
        <div id='header-connected' className='container-header container-header-checkout bg-brand-2 container-fluid pt-0 d-print-none d-md-flex align-items-center' role='banner'>
          <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
            <a
              className={`btn-back-page btn-back-page-mobile p-1 px-2 btn-sm btn-flat color-ui-white border-none btn-icon txt-button txt-font-body`}
              href='javascript:void(0)'
              onClick={(e) => handleBackStep(e)}
              aria-label='Voltar'
            >
              <Icon
                className='icon icon-lg color-ui-white'
                iconName='icon_left_app'
              />
              <span className='d-none d-md-inline-block color-ui-white pl-2' aria-hidden>Voltar</span>
            </a>
            <div className='container container-with-zoom h-100 mx-md-auto'>
              <div id='header' className='header mt-2 row row-eq-height h-100'>
                <Logo />
              </div>
            </div>
            <Link
              className={`btn-back-page btn-back-page-mobile p-1 px-2 btn-sm btn-flat color-ui-white border-none btn-icon txt-button txt-font-body`}
              to='/cart'
              aria-label='Carrinho'
            >
              <Icon
                className='icon icon-lg color-ui-white'
                iconName='icon_cart'
              />
              <span className='d-none d-md-inline-block color-ui-white pl-2' aria-hidden>Carrinho</span>
            </Link>
          </div>
        </div>
      </MediaQuery>

      <MediaQuery minWidth={481}>
        <div id='header-connected' className='container-header container-header-checkout bg-brand-2 container-fluid pt-0 d-print-none d-md-flex align-items-center' role='banner'>
          <div className='content-checkout w-100 h-100 d-flex justify-content-center align-items-center'>
            <div className='container container-with-zoom h-100 mx-md-auto mt-3'>
              <div id='header' className='header row row-eq-height h-100'>
                <Logo className='p-1 px-2 mx-md-auto' />
              </div>
            </div>
            <Link
              className={`content-voltar btn-back-page btn-back-page-desktop mx-md-auto p-1 px-2 btn-sm btn-flat color-ui-white border-none btn-icon txt-button txt-font-body`}
              to='/cart'
              aria-label='Voltar para o carrinho'
            >
              <Icon
                className='icon icon-lg color-ui-white'
                iconName='icon_left_app'
              />
              <span className='d-md-inline-block color-ui-white pl-2 text-big-checkout' aria-hidden>Voltar para o carrinho</span>
            </Link>
          </div>
        </div>
      </MediaQuery>
    </Fragment>
  )
}

export default BasicHeader



// WEBPACK FOOTER //
// ./src/App/Header/HeaderCheckout.js